"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XeroAPIErrorCode = void 0;
var XeroAPIErrorCode;
(function (XeroAPIErrorCode) {
    XeroAPIErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    XeroAPIErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    XeroAPIErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    XeroAPIErrorCode["MISSING_TENANT_ID"] = "MISSING_TENANT_ID";
    XeroAPIErrorCode["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
    XeroAPIErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    XeroAPIErrorCode["API_ERROR"] = "API_ERROR";
})(XeroAPIErrorCode || (exports.XeroAPIErrorCode = XeroAPIErrorCode = {}));
